import { render, staticRenderFns } from "./dispatchFooter.vue?vue&type=template&id=36e487bc&scoped=true"
import script from "./dispatchFooter.vue?vue&type=script&lang=js"
export * from "./dispatchFooter.vue?vue&type=script&lang=js"
import style0 from "./dispatchFooter.vue?vue&type=style&index=0&id=36e487bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e487bc",
  null
  
)

export default component.exports